// Send Logs' console ring (docs/features/send-logs.md › The bundle): the page's last 2000 lines — console.log, info,
// warn, error and debug (each still printed as before), the window's uncaught errors and unhandled rejections — each
// "HH:MM:SS.mmm level text", an Error as its stack, a line cut at 2000 characters. Nothing leaves the page from here:
// bundle.js reads `lines()` when the person taps Send Logs.
//
// It imports nothing and installs itself as it loads: sendlogs/index.js imports it first, and app.js imports that
// first, so the ring hears everything after the page's first module.

export const MAX_LINES = 2000
export const MAX_WIDTH = 2000
const LEVELS = ['log', 'info', 'warn', 'error', 'debug']

const ring = []

/// The ring as it stands, oldest first.
export function lines() { return ring.slice() }

const two = (n, w = 2) => String(n).padStart(w, '0')
const stamp = (d) => `${two(d.getHours())}:${two(d.getMinutes())}:${two(d.getSeconds())}.${two(d.getMilliseconds(), 3)}`

function textOf(value) {
  if (value instanceof Error) return value.stack || `${value.name}: ${value.message}`
  if (typeof value === 'string') return value
  if (value === undefined) return 'undefined'
  try { return JSON.stringify(value) ?? String(value) } catch { try { return String(value) } catch { return '?' } }
}

/// One line into the ring (the console's, an error's, a test's).
export function push(level, args, now = new Date()) {
  let line = `${stamp(now)} ${level} ${(Array.isArray(args) ? args : [args]).map(textOf).join(' ')}`
  if (line.length > MAX_WIDTH) line = line.slice(0, MAX_WIDTH - 1) + '…'
  ring.push(line)
  if (ring.length > MAX_LINES) ring.splice(0, ring.length - MAX_LINES)
}

/// Wraps `target`'s console and hears its window's errors — once per target, however often it is called.
export function install(target = globalThis) {
  if (!target || target.__codyLogRing) return
  target.__codyLogRing = true
  const out = target.console
  for (const level of LEVELS) {
    const original = out?.[level]
    if (typeof original !== 'function') continue
    out[level] = function (...args) {
      try { push(level, args) } catch {}
      return original.apply(this, args)
    }
  }
  target.addEventListener?.('error', (e) => {
    try { push('error', [e?.error instanceof Error ? e.error : `${e?.message || 'error'}${e?.filename ? ` (${e.filename}:${e.lineno}:${e.colno})` : ''}`]) } catch {}
  })
  target.addEventListener?.('unhandledrejection', (e) => {
    try { push('error', ['unhandled rejection:', e?.reason]) } catch {}
  })
}

install()
